import type {CostProductUnit} from './finance-cost-document-api';
export const costDocumentMoney=(value:string)=>{
  const parsed=/^(0|[1-9]\d{0,12})(?:[.,](\d{1,6}))?$/.exec(value.trim());
  return parsed?`${parsed[1]}.${(parsed[2]??'').padEnd(6,'0')}`:null;
};
export function costProductTotal(units:CostProductUnit[]){
  let sum=0n;
  for(const u of units){const price=costDocumentMoney(u.unitCost);
    if(!price||!Number.isSafeInteger(u.unitFrom)||!Number.isSafeInteger(u.unitThrough)||u.unitFrom<1||u.unitThrough<u.unitFrom)return null;
    sum+=(BigInt(u.unitThrough)-BigInt(u.unitFrom)+1n)*BigInt(price.replace('.',''));
  }
  return costDocumentMoney(`${sum/1000000n}.${String(sum%1000000n).padStart(6,'0')}`);
}
